export const MAURO_ACCOUNT_ID = '1';
export const VIVIAN_ACCOUNT_ID = '4';

const APPOINTMENT_ACCOUNT_FEATURES = {
  [MAURO_ACCOUNT_ID]: {
    enabled: true,
    showConsultationNumber: true,
    showRecurrence: true,
  },
  [VIVIAN_ACCOUNT_ID]: {
    enabled: true,
    showConsultationNumber: false,
    showRecurrence: false,
  },
};

export const appointmentFeaturesForAccount = accountId =>
  APPOINTMENT_ACCOUNT_FEATURES[String(accountId)] || {
    enabled: false,
    showConsultationNumber: false,
    showRecurrence: false,
  };

export const APPOINTMENT_FIELDS = {
  date: 'proximo_agendamento_data',
  time: 'proximo_agendamento_horario',
  duration: 'agendamento_duracao_minutos',
  title: 'agendamento_resumo',
  mode: 'agendamento_modalidade',
  type: 'agendamento_tipo',
  recurrence: 'agendamento_recorrencia',
  consultationNumber: 'agendamento_numero_consulta',
  history: 'agendamento_historico',
  lastOutcome: 'agendamento_ultimo_resultado',
  googleEventId: 'agendamento_google_event_id',
  googleCalendarId: 'agendamento_google_calendar_id',
  syncFingerprint: 'agendamento_sync_hash',
  syncStatus: 'agendamento_sync_status',
};

export const APPOINTMENT_ATTRIBUTE_KEYS = new Set(
  Object.values(APPOINTMENT_FIELDS)
);

export const appointmentRangeFromAttributes = attributes => {
  const date = String(attributes?.[APPOINTMENT_FIELDS.date] || '');
  const time = String(attributes?.[APPOINTMENT_FIELDS.time] || '');
  const duration = Number(attributes?.[APPOINTMENT_FIELDS.duration]);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(time)) {
    return null;
  }
  const start = new Date(`${date}T${time}:00`);
  if (Number.isNaN(start.getTime()) || !Number.isFinite(duration)) return null;
  return { start, due: new Date(start.getTime() + duration * 60000) };
};
